<div *ngIf="loading$ | async" class="flex justify-center items-center h-screen fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 z-[9999]">
    <p-progressSpinner strokeWidth="5" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
</div>
